import { CircularProgress, Stack, Typography } from "@mui/material";
import React from "react";

interface LoadingStateProps {
  label: React.ReactNode;
}

/** A consistent activity indicator and label for in-content loading states. */
export const LoadingState: React.FC<LoadingStateProps> = ({ label }) => (
  <Stack spacing={1} justifyContent="center" alignItems="center" role="status">
    <CircularProgress size={26} />
    <Typography variant="body2" color="text.secondary" fontWeight={600}>
      {label}
    </Typography>
  </Stack>
);
